import { createFileRoute } from '@tanstack/react-router'

import { AnalyticsContentTabPanel } from '@/analytics/components/AnalyticsContentTabPanel/AnalyticsContentTabPanel'
import { TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED } from '@/core/constants/constants'
import { track } from '@/core/utils/tracking/track'

export const Route = createFileRoute('/company/_management/analytics/content')({
  component: AnalyticsContentTabPanel,
  onEnter: () => {
    track(TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED, {
      dashboard_page: 'content',
    })
  },
})
